import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import ItemCount from '../ItemCount/ItemCount';
import { Link } from 'react-router-dom';
import { useCartContext } from '../Context/CartContext';
import DrinksDropdown from '../Drinks/DrinksDropdown';
import Dips from '../Dips/Dips';
import MedallonesDropdown from '../Extra/MedallonesDropdown';
import "../ItemDetail/ItemDetail.css";
import axios from 'axios';

const ItemDetail = ({ item }) => {
  const { addProduct, selectedSize, setSelectedSize, selectedDrink, setSelectedDrink, selectedDip, anotaciones, setAnotacion, precioExtra, precioBebida, setCurrentPrice } = useCartContext();
  
  const [goToCart, setGoToCart] = useState(false);
  const [acomp, setAcomp] = useState("Papas fritas");
  const [precioExtras, setPrecioExtras] = useState(0);
  const [medallonesExtras, setMedallonesExtras] = useState(0);
  const [moduloBebida, setModuloBebida] = useState(false);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
  

  let imagenes = [];

  try {
    imagenes = Array.isArray(item.image)
      ? item.image
      : item.image
      ? JSON.parse(item.image)
      : [];
  } catch (e) {
    imagenes = item.image ? [item.image] : [];
  }
  
// Si aún no hay imagen seleccionada, usá la primera por defecto
useEffect(() => {
  if (imagenes.length > 0 && !imagenSeleccionada) {
    setImagenSeleccionada(imagenes[0]);
  }
}, [imagenes, imagenSeleccionada]);

  useEffect(() => {
    obtenerEstadoModuloBebida();
  }, []);

  const obtenerEstadoModuloBebida = async () => {
    try {
      const response = await axios.get('https://pedir-imperfctt.p89nps.easypanel.host/phone');
      setModuloBebida(response.data.length > 0 && response.data[0].modulo_bebida === 1);
    } catch (error) {
      console.error("Error al obtener el estado del módulo de bebidas:", error);
    }
  };

  // 🚀 **Memoización del precio base**
  const precioBase = useMemo(() => selectedSize === 'simple' ? item.simple : item.doble, [selectedSize, item]);

  // 🚀 **Cálculo del precio final**
  const calcularPrecioFinal = useCallback(() => {
    return precioBase + precioExtras + (selectedDrink?.precio || 0);
  }, [precioBase, precioExtras, selectedDrink]);

  // 🚀 **Actualizar precio en el contexto cuando cambian valores relevantes**
  useEffect(() => {
    setCurrentPrice(calcularPrecioFinal());
  }, [calcularPrecioFinal, setCurrentPrice]);

  // 🚀 **Actualizar estado del formulario**
  const formComplete = useMemo(() => (
    selectedSize !== '' && acomp !== '' && selectedDip !== '' && (moduloBebida ? selectedDrink !== '' : true)
  ), [selectedSize, acomp, selectedDip, selectedDrink, moduloBebida]);

  // 🚀 **Manejo del cambio de medallones extra**
  const handleMedallonesExtraChange = (value) => {
    setMedallonesExtras(value);
    setPrecioExtras(value * precioExtra.extraPrice);
  };

  // 🚀 **Manejo de añadir producto**
  const onAdd = (quantity) => {
    setGoToCart(true);
    addProduct(item, quantity, selectedSize, precioBase, acomp, selectedDrink, selectedDip, anotaciones, { medallones: medallonesExtras });
  };

  return (
    <Container className="mt-4 back-checkout">
      {/* Imagen y Nombre */}
      <Row className="justify-content-center text-center mb-4">
        <Col xs={12}>
          <h5 className='card-title'>{item.name}</h5>
          {imagenSeleccionada && (
  <img
    src={imagenSeleccionada}
    alt="Imagen principal"
    style={{
      width: '100%',
      maxHeight: '300px',
      objectFit: 'contain',
      borderRadius: '8px',
      marginBottom: '10px'
    }}
  />
)}
{imagenes.length > 1 && (
  <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
    {imagenes.map((img, idx) => (
      <img
        key={idx}
        src={img}
        alt={`Miniatura ${idx + 1}`}
        onClick={() => setImagenSeleccionada(img)}
        style={{
          width: '60px',
          height: '60px',
          objectFit: 'cover',
          border: img === imagenSeleccionada ? '2px solid #007bff' : '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      />
    ))}
  </div>
)}


        </Col>
      </Row>

      {/* Descripción */}
      <Row className="justify-content-center text-center mb-4">
        <Col xs={12}>
          <h5 className='card-title'>Descripción:</h5>
          <p classNAme='card-title'>{item.description}</p>
        </Col>
      </Row>

      {/* Selección de Bebidas */}
      {moduloBebida && (
        <Row className="g-1 mb-3 justify-content-center text-center">
          <Col xs={12} md={6}>
            <b className='underline'>Bebida</b>
            <DrinksDropdown />
          </Col>
        </Row>
      )}

      {/* Anotaciones */}
      <Row className="mb-3 justify-content-center text-center">
        <Col xs={12}>
          <b className='underline'>Anotaciones</b>
          <textarea
            className="form-control"
            placeholder='Ingrese anotaciones'
            value={anotaciones}
            onChange={(e) => setAnotacion(e.target.value)}
          />
        </Col>
      </Row>

      {/* Precio Final */}
      <Row className="mb-3 text-center">
        <Col xs={12}>
          <h3><b>Precio: ${item.precio}</b></h3>
        </Col>
      </Row>

      {/* Botón de Añadir */}
      <Row className="text-center">
        <Col>
          <ItemCount stock={10} initial={1} onAdd={onAdd} disabled={!formComplete} />
          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default ItemDetail;
